"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgMusicNote01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M19.968 4.199c-.138.01-.329.042-.667.098l-8.8 1.467a7.537 7.537 0 0 0-.482.088l-.01.003v.01a7.57 7.57 0 0 0-.009.49v11.649a4 4 0 1 1-2-3.469V6.327c0-.216 0-.43.014-.613a2.01 2.01 0 0 1 .161-.685 2 2 0 0 1 .718-.847 2.01 2.01 0 0 1 .649-.272c.178-.044.39-.079.603-.115l8.862-1.477a10 10 0 0 1 .804-.113c.254-.02.564-.019.885.1a2 2 0 0 1 1.039.88c.17.298.223.604.245.858.02.235.02.516.02.81V16a1 1 0 0 1-.013.163A4 4 0 1 1 20 12.541V4.889c0-.343 0-.536-.013-.674l-.002-.017h-.017Z", fill: "currentColor" }) }))); };
exports.default = SvgMusicNote01;
